import React from 'react';
import { Box, TablePagination } from '@mui/material';
import InvButton from '../../../components/InvButton';
import { IPD_COLORS } from '../../../theme';

const DEFAULT_OPTIONS = [10, 25, 50];

/**
 * List footer matching InvDataGrid / PO: rows-per-page, range, prev/next.
 *
 * `total` is what the client currently holds, not a server count — the ward-return
 * list endpoint returns no reliable total, so when `hasMore` is set the label
 * appends "+" and a Load more button fetches the next chunk.
 */
export default function TablePaginationBar({
  page,
  rowsPerPage,
  total,
  rowsPerPageOptions = DEFAULT_OPTIONS,
  onPageChange,
  onRowsPerPageChange,
  hasMore = false,
  onLoadMore,
  loadingMore = false,
}) {
  const pageCount = Math.max(1, Math.ceil(total / rowsPerPage));
  const zeroBasedPage = total === 0 ? 0 : Math.min(Math.max(page, 1), pageCount) - 1;

  return (
    <Box sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 1,
      borderTop: `1px solid ${IPD_COLORS.border}`,
      backgroundColor: IPD_COLORS.panelHeaderBg,
      minHeight: 48,
    }}>
      {hasMore && onLoadMore && (
        <InvButton variant="outlined" tone="teal" size="small" onClick={onLoadMore} loading={loadingMore}>
          Load more
        </InvButton>
      )}
      <TablePagination
        component="div"
        count={total}
        page={zeroBasedPage}
        onPageChange={(e, next) => onPageChange(next + 1)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => onRowsPerPageChange(Number(e.target.value))}
        rowsPerPageOptions={rowsPerPageOptions}
        labelRowsPerPage="Rows per page:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}–${to} of ${count}${hasMore ? '+' : ''}`
        }
        sx={{
          color: IPD_COLORS.textSecondary,
          border: 'none',
          '& .MuiTablePagination-toolbar': { minHeight: 48, px: 1, alignItems: 'center' },
          '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': { m: 0 },
        }}
      />
    </Box>
  );
}
